export const EffectSelectionOptions = {
    ENERGY: 'energy',
    CONFIDENCE: 'confidence',
    REPUTATION: 'reputation',
    BELONGING: 'belonging',
    RESPONSIBILITY: 'responsibility',
    LEARNING: 'learning',
    NO_OTHER_EFFECTS: 'no-other-effects',
    CONNECTION: 'connection',
    MEANINGFUL: 'meaningful',
};
